import { useEffect, useState } from 'preact/hooks'
import { ON_ACTION_CARD_SAVE_EVENT } from '../constants/index'
import { getLocalData } from '../services/storage.js'
import { useAppContext } from '../contexts/AppContext'

function useActionCardData() {
  const [actionCardData, setActionCardData] = useState(null)
  const { playbookId } = useAppContext()

  useEffect(() => {
    const updateActionCardData = async function () {
      const result = await getLocalData(playbookId)
      setActionCardData(result)
    }

    window.addEventListener(ON_ACTION_CARD_SAVE_EVENT, updateActionCardData)
    return () => {
      window.removeEventListener(ON_ACTION_CARD_SAVE_EVENT, updateActionCardData)
    }
  }, [])

  return actionCardData
}

export default useActionCardData
